import { getPrompt } from "../utils/promptUtils";

export const pwd = {
    name: "pwd",
    description: "Prints current directory",
    run: (_: string[], context: any) => {
        return getPrompt(context.currentDir).slice(0, -2);
    }
};